import React from "react";
 
function UCISVG () {
  return (
    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="100%" height="100%" viewBox="0 0 300.000000 318.000000"
    preserveAspectRatio="xMidYMid meet">
      <metadata>
        Created by potrace 1.10, written by Peter Selinger 2001-2011
      </metadata>
      <g transform="translate(0.000000,318.000000) scale(0.050000,-0.050000)"
      stroke="none">
        <path d="M1040 6010 l0 -210 165 0 165 0 -5 -630 c-2 -346 2 -630 10 -630 8
        -1 116 24 240 54 l225 54 0 576 0 576 170 0 170 0 0 210 0 210 -570 0 -570 0
        0 -210z"/>
        <path d="M3840 6010 l0 -210 170 0 170 0 0 -557 0 -557 165 -23 c91 -13 199
        -29 240 -36 l75 -12 0 592 0 593 170 0 170 0 0 210 0 210 -580 0 -580 0 0
        -210z"/>
        <path d="M2440 5210 l0 -210 170 0 170 0 0 -1780 0 -1780 -170 0 -170 0 0
        -210 0 -210 570 0 570 0 0 210 0 210 -160 0 -160 0 0 1780 0 1780 160 0 160 0
        0 210 0 210 -570 0 -570 0 0 -210z"/>
        <path d="M2310 4590 c-2868 -331 -2821 -2463 60 -2738 319 -31 290 -53 290
        218 l0 228 -85 10 c-47 6 -175 20 -285 33 -579 64 -1098 246 -1398 490 -624
        508 80 1121 1473 1282 l295 35 0 236 0 236 -65 -2 c-36 -2 -164 -14 -285 -28z"/>
        <path d="M3380 4382 l0 -242 97 0 c515 0 1358 -157 1783 -332 94 -39 180 -72
        193 -74 25 -4 287 330 287 366 0 22 -179 109 -394 191 -424 160 -1059 276
        -1751 320 l-215 14 0 -243z"/>
        <path d="M4180 3227 c0 -625 4 -727 29 -727 16 0 122 18 235 40 113 22 208 40
        211 40 3 0 3 290 0 644 l-5 643 -60 16 c-33 9 -139 28 -235 43 l-175 28 0
        -727z"/>
        <path d="M1650 3852 c-77 -25 -174 -60 -216 -78 l-76 -33 6 -525 6 -526 220
        -74 c121 -41 227 -74 235 -75 8 -1 15 305 15 679 0 532 -5 680 -25 678 -14 -1
        -88 -22 -165 -46z"/>
        <path d="M5240 2627 c-396 -163 -1303 -327 -1813 -327 -47 0 -47 -1 -47 -242
        l0 -242 175 13 c804 59 1324 153 1780 323 276 103 390 163 371 196 -60 100
        -256 352 -274 351 -12 -1 -98 -33 -192 -72z"/>
        <path d="M1380 1603 c1 -912 500 -1404 1475 -1455 1128 -58 1773 437 1801
        1384 l9 302 -218 -36 c-119 -20 -228 -37 -242 -37 -18 -1 -25 -54 -25 -196 -2
        -654 -359 -936 -1180 -934 -821 3 -1159 298 -1160 1014 0 85 -7 155 -15 155
        -8 0 -112 26 -230 58 l-215 57 0 -312z"/>
      </g>
    </svg>
  );
}
 
export default UCISVG;
